<template>
  <div class="home">
    <div class="web_class" v-if="!isMobile">
      <div class="webPosition">
        <div class="web_title">
          <div class="home_title">Physical Data, For AI</div>
          <div class="sub_title">
            The Data Layer for Physical AI Training
          </div>
        </div>
      </div>

      <div class="home_info generateTop">
        <div class="inputBtnclass">
           <div class="inputClick">
              <img @click="ShowGenerateFn" src="../assets/svg/icon3D.svg" />
              <div @click="ShowGenerateFn" class="typingText">{{ currText }}</div>
              <a @click="showUpload"  class="generate">Upload</a>
            </div>
        </div>

        <div class="promptList webList">
          <div class="promptTitle">
            <div style="margin: -9px 0 12px -13px;">Spatial 3D Data Example</div>
            <video class="video_item" width="100%" autoplay muted loop webkit-playsinline="true" playsinline="true" style="border-radius: 8px;">
              <source src="../assets/video/example_01.mp4" type="video/mp4">
              <source src="../assets/video/example_01.mp4" type="video/ogg">
              <source src="../assets/video/example_01.mp4" type="video/webm">
              <object data="../assets/video/example_01.mp4">
                <embed src="../assets/video/example_01.mp4">
              </object>
            </video>
          </div>
        </div>
      </div>

      <div class="video_item video_dom1">
        <video class="video1"  muted autoplay="autoplay" loop>
          <source src="../assets/01-02compesit.mp4" type="video/mp4" />
          <source src="../assets/01-02compesit.mp4" type="video/ogg" />
          <source src="../assets/01-02compesit.mp4" type="video/webm" />
          <object data="../assets/01-02compesit.mp4">
            <embed src="../assets/01-02compesit.mp4" />
          </object>
        </video>
      </div>
    </div>
    <div v-if="isMobile" class="videoBg" :class="isWeixin?'weixinClass':''">
      <video ref="videoBg" width="100%"  autoplay="true" loop="true" muted webkit-playsinline="true" playsinline="true" >
        <source  src="../assets/0001-0200.mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="mobile_class" v-if="isMobile">
      <div class="mobile_content">
        <div class="mobile_title">
          <div>Physical Data, For AI</div>
          <div>The Data Layer for Physical AI Training</div>
        </div>

        <div
          class="mobile_inputClick"
          @click="ShowGenerateFn"
          v-if="!showGenerate"
        >
          <img src="../assets/svg/icon3D.svg" />
          <div class="typingText">{{ currText }}</div>
          <a class="generate">Upload</a>
        </div>
        <div class="mobilePromptList">
          <div class="promptTitle">
            <div style="margin: -9px 0 12px -13px;">Spatial 3D Data Example</div>
            <video class="video_item" width="100%" autoplay muted loop webkit-playsinline="true" playsinline="true" style="border-radius: 8px;">
              <source src="../assets/video/example_01.mp4" type="video/mp4">
              <source src="../assets/video/example_01.mp4" type="video/ogg">
              <source src="../assets/video/example_01.mp4" type="video/webm">
              <object data="../assets/video/example_01.mp4">
                <embed src="../assets/video/example_01.mp4">
              </object>
            </video>
          </div>
        </div>
      </div>
      <div class="empty"></div>
    </div>
    <UploadGlb ref="uploadGlb" :glbUrl="glbUrl" />
  </div>
</template>

<script>
import GltfView from '../components/GltfView'
import * as api from '../service/getData'
import UploadGlb from '../components/UploadGlb'
export default {
  name: 'About',
  data () {
    return {
      src: [
        require('../assets/03.mp4'),
        require('../assets/03.mp4'),
        require('../assets/03.mp4')
      ],
      config: null,
      gtext: '',
      loading: false,
      text: 'Spatial 3D Data',
      currText: '',
      isMobile: false,
      promptArr: [],
      textInterval: null,
      isWeixin: false,
      animatorInterval: null,
      glbUrl: null,
      showDownImg: false
    }
  },
  async mounted () {
    this.isMobile = this.isMobileFn()
    // var data = await api.getTextTo3DConfigController();
    // if (data.message === "OK" && data.error === "") {
    //   this.config = data.data;
    // }
    this.rebuildInterval()
    var prompt = await api.getTextTo3Dprompt()
    if (prompt.message === 'OK' && prompt.error === '') {
      this.promptArr = prompt.data
    }
    window.onresize = () => {
      this.isMobile = this.isMobileFn()
    }
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWeixin = true
    }
  },

  components: {
    GltfView,
    UploadGlb
  },
  methods: {
    hideUploadImg () {
      this.showDownImg = false
    },
    showUpload () {
      this.$refs.uploadGlb.showUpload()
    },
    changeMessage () {
      this.gtext = this.$refs.sendInput.innerHTML
    },
    selectFocus () {
      this.$refs.sendInput.focus()
    },
    rebuildInterval () {
      if (this.textInterval) {
        clearInterval(this.textInterval)
        this.currText = ''
      }
      var arr = this.text.split('')
      var i = 0
      this.textInterval = setInterval(() => {
        if (i >= arr.length) {
          this.currText = ''
          i = 0
        } else {
          this.currText = this.currText + arr[i]
          i++
        }
      }, 200)
    },
    isMobileFn () {
      var userAgentInfo = navigator.userAgent
      var mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone']
      var mobile_flag = false
      // 根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true
          break
        }
      }

      return mobile_flag
    },
    downGlbFn () {
      this.$refs.uploadGlb.showDownGlbFn(this.glbUrl)
    },
    autofocusFn () {
      const doc = document
      const input = doc.querySelector('#hide-focus-input')
      let dom = null
      // 1.检查文档有没有一个id为hide-focus-input的input标签
      // 2.如果有,dom等于这个input标签
      // 3.如果没有，则创建一个id为hide-focus-input的input标签，并添加样式(第一次执行时走这步)
      // 4.调通input的原生focus方法来聚焦
      if (input) {
        dom = input
      } else {
        dom = doc.createElement('input')
        dom.setAttribute('id', 'hide-focus-input')
        dom.style = 'position: fixed; z-index: -9999; width: 0; height: 0'
        doc.body.appendChild(dom)
      }
      dom.focus()
    },
    ShowGenerateFn () {
      this.autofocusFn()
      this.showGenerate = true
      setTimeout(() => {
        this.$refs.sendInput.focus()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 767px) {
  .empty{
    height:50px;
  }
  .web_class {
    display: none;
  }
  .home {
    width: 100%;
    height: 100%;
  }
  .threeDContent {
    width: 100%;
    height: 188px;
    margin-top: 9px;
    .closeIcon {
      position: absolute;
      right: 8px;
      top: 8px;
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }
  .loading {
    padding-top: 79px;
    img {
      width: 29px;
      height: 29px;
    }
  }
}
@media (min-width: 768px) {
  video {
  //min-width: 1480px;
}
  .mobile_class {
    display: none;
  }
  .home {
    width: 100%;
    height:100%;
    overflow: hidden;
  }
  .threeDContent {
    width: 520px;
    height: 352px;
    margin-top: 20px;
    .closeIcon {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }
  .loading {
    padding-top: 149px;
  }
}
.gltfView {
  width: 100%;
  height: 100%;
}
.loading {
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
  img {
    animation: rotate 1s linear infinite;
  }
}
.video_item {
  position: relative;
  width: 100%;
}
.video_dom2 {
  display: none;
}
.home_info {
  position: absolute;
  left: 8%;
  z-index: 15;
  top: 50%;
}

.threeDContent {
  border-radius: 10px;
  background: rgba(230, 230, 230, 1);
  overflow: hidden;
  position: relative;
}
.web_title {
  margin-bottom:30px;
  > div:nth-child(1) {
    width: 520px;
    color: #fff;
    text-align: left;
    font-family: "EncodeSans-Bold";
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    font-size: 67px;
    font-style: normal;
    font-weight: 700;
    line-height: 74px; /* 110.448% */
    letter-spacing: -2.01px;
  }
  > div:nth-child(2) {
    width: 750px;
    color: var(--neutral-200, #E4E8E8);
    margin-top: 20px;
    font-family: "EncodeSans-Medium";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
}
.web_title_small {
  margin-bottom: 10px;
  > div:nth-child(1) {
    color: #fff;
    font-family: "EncodeSans-Bold";
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px; /* 120% */
    letter-spacing: -0.3px;
  }
  > div:nth-child(2) {
    color: var(--Neutral-200, #E4E8E8);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    font-family: "EncodeSans-Medium";
  }
}
.video_mask {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  background: #040605;
  opacity: 0.1;
}

.inputClick {
  border-radius: 12px;
  background: #fff;
  position: relative;
  width: 385px;
  height: 70px;
  > div:nth-child(2) {
    color: #b2b2b2;
    padding-left: 52px;
    line-height: 70px;
    font-size: 22px;
    font-family: "EncodeSans-Medium";
  }
  >img {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 8px;
  }
  .generate:hover {
    background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
  }
  .generate {
    height: 54px;
    position: absolute;
    width: 115px;
    right: 7px;
    top: 8px;
    text-align: center;
    line-height: 54px;
    border-radius: 10px;
    color: #3f3f3f;
    font-size: 20px;
    cursor: pointer;
    background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
    animation: scaleAnimation 0.3s ease-in-out 0s infinite alternate;
    font-family: "EncodeSans-Medium";
  }
}

.textToThreeD {
  border-radius: 12px;
  background: #fff;
  position: relative;
  width: 520px;
  height:70px;
  > div:nth-child(2) {
    background: none;
    border: none;
    font-size: 22px;
    outline: none;
    cursor: pointer;
    font-family: "EncodeSans-Medium";
    color: #000;
    margin-left: 52px;
    margin-right: 129px;
    line-height: 70px;
  }
  >img {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 8px;
  }
  .generate {
    height: 54px;
    position: absolute;
    width: 115px;
    right: 7px;
    bottom: 7px;
    text-align: center;
    line-height: 54px;
    border-radius: 10px;
    color: #3f3f3f;
    font-size: 20px;
    cursor: pointer;
     background: var(--Button-Linear-Default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
    font-family: "EncodeSans-Medium";
  }
  .generate:hover {
     background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
  }
}
.mobile_inputClick {
  border-radius: var(--Corner02, 8px);
  background: #fff;
  position: relative;
  width: 100%;
  height: 48px;
  margin-top: 16px;
  > div {
    color: #b2b2b2;
    padding-left: 45px;
    line-height: 48px;
    font-size: 15px;
    font-family: "EncodeSans-Medium";
  }
  img {
     width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 3px;
  }
  .generate:hover {
     background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
  }
  .generate {
    height: 38px;
    position: absolute;
    width: 92px;
    right: 5px;
    top: 5px;
    text-align: center;
    line-height: 38px;
    color: var(--Neutral-900, #101313);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    border-radius: var(--Corner02, 8px);
    background: var(--Button-Linear-Default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
    animation: scaleAnimation 0.5s ease 0s infinite alternate;
    font-family: "EncodeSans-Medium";
  }
}
.moible_textToThreeD {
  min-height: 18px;
  margin-top: 16px;
  border-radius: var(--Corner02, 8px);
  background: #fff;
  position: relative;
  padding-right: 91px;
  padding: 15px 91px 15px 45px;
  > div {
    background: none;
    border: none;
    font-size: 15px;
    outline: none;
    cursor: pointer;
    font-family: "EncodeSans-Medium";
    color: #000;
  }
  img {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 3px;
  }
  .generate {
    height: 38px;
    position: absolute;
    width: 92px;
    right: 5px;
    bottom: 5px;
    text-align: center;
    line-height: 38px;
    border-radius: var(--Corner02, 8px);
    color: var(--Neutral-900, #101313);
    cursor: pointer;
    background: var(--button-linear-default, linear-gradient(90deg, #0FF 25.99%, #6DFBB7 100%));
    font-family: "EncodeSans-Medium";
    font-size: 14px;
    font-weight: 600;
  }
  .generate:hover {
     background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
  }
}
@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes scaleAnimation {
  from {
    transform: scale(0.94);
  }

  100%,
  to {
    transform: scale(1);
  }
}

.mobile_class {
  position:absolute;
  z-index:3;
  width: 100%;
  height: 100%;
  overflow-y: auto;

}
.weixinClass{
  background:url("../assets/h5_bg.png");
  background-size: 100% 100%;
}
.mobile_title {
  padding-top: 121px;
  > div:nth-child(1) {
    color: #fff;
    width:300px;
    font-family: "EncodeSans-Bold";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; /* 120% */
    letter-spacing: -0.3px;
  }
  > div:nth-child(2) {
    color: var(--Neutral-200, #E4E8E8);
    width:300px;
    font-family: "EncodeSans-Medium";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 17px;
    margin-top: 12px;
  }
}
.mobile_content {
  padding: 0px 20px;
}
.mobile_logo {
  position: absolute;
  width: 140px;
  height: 35px;
  left: 44px;
  top: 26px;
  img {
    width: 100%;
    height: 100%;
  }
}
.webList {
  width: 345px;
}
.promptList {
  padding: 20px;
  border-radius: 8px;
  opacity: 0.93;
  margin-top:32px;
  border-radius: var(--Corner01, 10px);
  background: var(--opacity-neu-10010, rgba(246, 247, 247, 0.10));
  .promptTitle {
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 17px;
    color: var(--Shade-0, #FFF);
  }
  .promptItem {
    display: inline-block;
    padding: 12px;
    color: #fff;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 5px;
    margin-right: 5px;
    cursor: pointer;
     border-radius: var(--Corner02, 8px);
    background: #303030;
  }
  .promptItem:last-child {
    margin-bottom: 0px;
  }
}
.webPosition {
  bottom:50%;
  position:absolute;
  left:8%;
  z-index:55;
}
.videoBg {
  position:absolute;
  width:100%;
  height:100%;
  overflow: hidden;
  video{
    width:100%;
    margin-top:-8%;
  }
}
.uploadBtn {
  width: 54px;
  height: 54px;
  border-radius: var(--Corner01, 10px);
  background: linear-gradient(180deg, #0FF 0%, #FFF 100%);
  position:absolute;
  right:-74px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  overflow: hidden;
}
.uploadBtn:hover {
  background: var(--button-linear-hover, linear-gradient(90deg, #80FFFF 25.99%, #24F993 100%));
}

.uploadIcon {
   position:absolute;
   top:0px;
   animation: uploadTop 3s ease-out 0s;
   animation-fill-mode: forwards;
}
.coinIcon {
  top:100%;
  position:absolute;
  animation: coinTop 3s ease-out 0s;
  animation-fill-mode: forwards;
}
@keyframes uploadTop {
    0% {
        top: 0;
        opacity: 1;
    }
    80% {
        top: 0;
        opacity: 1;
    }
    100% {
        top: -100%;
        opacity: 0;
    }
}
@keyframes coinTop {
    0% {
        top: 100%;
        opacity: 0;
    }
    80% {
         top: 100%;
        opacity: 1;
    }
    100% {
        top: 0%;
        opacity: 1;
    }
}
.inputBtnclass {
  position:relative;
}

.mobilePromptList {
  padding: 16px;
  border-radius: 8px;
  opacity: 0.93;
  margin-top:16px;
  border-radius: var(--Corner01, 10px);
  background: var(--opacity-neu-10010, rgba(246, 247, 247, 0.10));
  .promptTitle {
    color: var(--Shade-0, #FFF);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }
  .promptItem {
    display: inline-block;
    padding: 10px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    margin-bottom: 5px;
    margin-right: 5px;
    cursor: pointer;
    border-radius: var(--Corner02, 8px);
    background: #303030;
    color: var(--P_font, #F4FAF7);
  }
  .promptItem:last-child {
    margin-bottom: 0px;
  }
}
.video1 {
  width:100%;
}
.downloadGlbBtn {
  position:absolute;
  bottom:25px;
  right:25px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue